module.exports = __webpack_public_path__ + "static/media/stop.febc583e.webp";